export const userRoleTypes = {
  author: "author",
  delivery: "delivery",
  all: "all",
}
